export default "__VITE_ASSET__BntSytr0__"